import React from "react";
import clsx from "clsx";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import HorseIcon from "components/Icons/Horse";
import Water from "components/Icons/Water";
import { useLoggedInUser } from "components/LoggedInUserProvider";
import { APPS } from "../constants";

import useStyles from "./styles";

interface Props {
  setCurrentActiveApp: (appName: APPS) => void;
  onSlideChange: (appName: APPS) => void;
}

const ApplicationSelector = (props: Props) => {
  const { setCurrentActiveApp, onSlideChange } = props;

  const classes = useStyles();
  const { currentUser } = useLoggedInUser();

  const isConditionsAvailable = true;
  const isBlackoutsAvailable =
    currentUser.isRacingOfficial ||
    currentUser.isChiefVet ||
    currentUser.isSeniorVet ||
    currentUser.isAdmin;

  if (!isConditionsAvailable && !isBlackoutsAvailable) {
    return (
      <div className={classes.noAppAvailable}>
        No management options available for this track
      </div>
    );
  }

  const handleAppLabelClick = appName => {
    setCurrentActiveApp(appName);
    onSlideChange(appName);
  };

  return (
    <>
      <div className={classes.applicationsList}>
        {isConditionsAvailable && (
          <div
            className={clsx(classes.appLabel, "first")}
            onClick={() => handleAppLabelClick(APPS.TrackConditions)}
          >
            <div className={classes.appLabelIconContainer}>
              <Water className={classes.appItemIcon} />
            </div>
            <div className={classes.appLabelContentContainer}>
              <div className={classes.appLabelName}>
                <div className={classes.mainName}>Track Conditions</div>
                <div className={classes.description}>
                  Update the physical conditions of track surfaces
                </div>
              </div>
              <ArrowForwardIosIcon className={classes.openAppIcon} />
            </div>
          </div>
        )}
        {isBlackoutsAvailable && (
          <div
            className={classes.appLabel}
            onClick={() => handleAppLabelClick(APPS.WorkoutScheduling)}
          >
            <div className={classes.appLabelIconContainer}>
              <HorseIcon className={classes.appItemIcon} />
            </div>

            <div className={classes.appLabelContentContainer}>
              <div className={classes.appLabelName}>
                <div className={classes.mainName}>Workout Scheduling</div>
                <div className={classes.description}>
                  Manage what days are available for workouts
                </div>
              </div>
              <ArrowForwardIosIcon className={classes.openAppIcon} />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ApplicationSelector;
